import { Validators } from '@angular/forms';
import { Geography } from '../../../../../../core/constants/geography';

export const LatitudeControlValidators = [
    Validators.required,
    Validators.min(Geography.latitudeUnitedStatesAndTerritoriesMinimum),
    Validators.max(Geography.longitudeUnitedStatesAndTerritoriesMaximum),
];

export const LongitudeControlValidators = [
    Validators.required,
    Validators.min(Geography.longitudeUnitedStatesAndTerritoriesMinimum),
    Validators.max(Geography.longitudeUnitedStatesAndTerritoriesMaximum),
];

export const LatitudeDegreesControlValidators = [
    Validators.required,
    Validators.min(Geography.latitudeLongitudeDegreesMinimum),
    Validators.max(Geography.latitudeUnitedStatesAndTerritoriesMaximum),
];

export const LatitudeMinutesControlValidators = [
    Validators.required,
    Validators.min(Geography.latitudeLongitudeMinutesMinimum),
    Validators.max(Geography.latitudeLongitudeMinutesMaximum),
];

export const LatitudeSecondsControlValidators = [
    Validators.required,
    Validators.min(Geography.latitudeLongitudeSecondsMinimum),
    Validators.max(Geography.latitudeLongitudeSecondsMaximum),
];

export const LatitudeDirectionControlValidators = [Validators.required];

export const LongitudeDegreesControlValidators = [
    Validators.required,
    Validators.min(Geography.latitudeLongitudeDegreesMinimum),
    Validators.max(Geography.longitudeUnitedStatesAndTerritoriesMaximum),
];

export const LongitudeMinutesControlValidators = [
    Validators.required,
    Validators.min(Geography.latitudeLongitudeMinutesMinimum),
    Validators.max(Geography.latitudeLongitudeMinutesMaximum),
];

export const LongitudeSecondsControlValidators = [
    Validators.required,
    Validators.min(Geography.latitudeLongitudeSecondsMinimum),
    Validators.max(Geography.latitudeLongitudeSecondsMaximum),
];

export const LongitudeDirectionControlValidators = [Validators.required];
